import { render, staticRenderFns } from "./CardAnswerPlaceholder.vue?vue&type=template&id=3d2a315c"
import script from "./CardAnswerPlaceholder.vue?vue&type=script&lang=js"
export * from "./CardAnswerPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports